// src/components/common/Avatar/ProfileAvatar.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Home,
  Users,
  User,
  Settings,
  LogOut,
  History,
  BookOpen,
  UserCheck,
  HelpCircle,
  Building,
  CalendarClock
} from "lucide-react";
import logo from '../../../Images/logo.png';
import "../../../styles/ProfileAvatarnew.css"
import MyProfile from "../../../pages/MyProfile";
import EmployeeForm from "../../employees/EmployeeForm";
import CourseCreationForm from "../../courses/CourseCreationForm";
import CourseDetailsView from "../../courses/CourseDetailsView";
import { fetchUserData } from "../../../services/authServicepa";
import { checkPermissions } from "../../../utils/permissions";

const ProfileAvatarsr = () => {
  const [email, setEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [showCourseForm, setShowCourseForm] = useState(false);
  const [showCourseDetails, setShowCourseDetails] = useState(false);
  const [showMyProfile, setShowMyProfile] = useState(false);
  const [branches, setBranches] = useState([]);
  const [showSupportPopup, setShowSupportPopup] = useState(false);
  const [locations, setLocations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getUserData = async () => {
      try {
        const userData = await fetchUserData();
        if (userData) {
          setEmail(userData.email_id || "");
          setUserRole(userData.role || "");
          setBranches(userData.branch || []);
          setLocations(userData.location || []);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    getUserData();
  }, []); // ✅ EMPTY dependency


// In your logout function
const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
};

  const handleMyProfileClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMyProfile(true);
  };

  const safeNavigate = (path) => {
    if (window.__guardedNavigate) {
      window.__guardedNavigate(path);
    } else {
      navigate(path);
    }
  };

  const navItems = [
    ...(["Super-Admin", "Branch-head"].includes(userRole) ? [{
      label: "Home Page",
      icon: Home,
      action: () => safeNavigate("/landingpage")
    }] : []),

    ...(["Trainer"].includes(userRole) ? [{
      label: "Home Page",
      icon: Home,
      action: () => safeNavigate("/staff-dashboard")
    }] : []),

    ...(["Placement officer"].includes(userRole) ? [{
      label: "Home Page",
      icon: Home,
      action: () => safeNavigate("/placementdb")
    }] : []),

    ...(["Placement officer", "Trainer", "Branch-head", "Super-Admin"].includes(userRole) ? [{
      label: "Placed Student",
      icon: UserCheck,
      action: () => safeNavigate("/placedready")
    }] : []),

    ...(["Trainer", "Branch-head", "Super-Admin"].includes(userRole) ? [{
      label: "Mentor Dashboard",
      icon: History,
      action: () => safeNavigate("/old-student-dashboard")
    }] : []),

    ...(["BDE", "Trainer", "Branch-head", "Super-Admin"].includes(userRole) ? [{
      label: "Student Entry Form",
      icon: BookOpen,
      action: () => safeNavigate("/students-form")
    }] : []),

    ...(["Super-Admin", "Branch-head", "Placement officer", "Trainer"].includes(userRole) ? [
      {
        label: "Create Job Requirement",
        icon: Building,
        action: () => safeNavigate("/placementofficer")
      },
      {
        label: "Job Dashboard",
        icon: CalendarClock,
        action: () => safeNavigate("/job-dashboard")
      }
    ] : []),

    ...(checkPermissions.canViewEmployees(userRole) ? [{
      label: "View Employees",
      icon: Users,
      action: () => safeNavigate("/employees")
    }] : []),
  ];

  const settingsItems = [
    ...(["Super-Admin"].includes(userRole) ? [{
      label: "Reset to Default Password",
      icon: Settings,
      action: () => navigate("/defaultpassword")
    }] : []),
    {
      label: "Support",
      icon: HelpCircle, // You can change icon to something like HelpCircle if you want
      action: () => setShowSupportPopup(true)
    },
    {
      label: "Logout",
      icon: LogOut,
      action: handleLogout
    }
  ];

  return (
    <>
      <div className="avatar-container">
        <div className="avatar-profile-container">
          <div className="avatar-button">
            <img src={logo} alt="PUMO TECHNOVATION" className="logo-image" />
          </div>
          <div className="avatar-emp-name">PUMO TECHNOVATION</div>
        </div>

        <div className="avatar-dropdown">
          <div className="dropdown-email">{email || "Fetching..."}</div>

          <div className="nav-section">
            <div className="nav-section-title">Main</div>
            {navItems.map((item, index) => (
              <button key={index} className="dropdown-item" onClick={item.action}>
                {React.createElement(item.icon, { size: 20, className: "navsb-icon" })}
                <span className="nav-label">{item.label}</span>
              </button>
            ))}
          </div>

          <div className="nav-section">
            <div className="nav-section-title">Profile</div>
            <button className="dropdown-item" onClick={handleMyProfileClick}>
              <User size={20} className="navsb-icon" />
              <span className="nav-label">My Profile</span>
            </button>
          </div>

          <div className="nav-section">
            <div className="nav-section-title">Settings</div>
            {settingsItems.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <button key={index} className="dropdown-item" onClick={item.action}>
                  <IconComponent size={20} className="navsb-icon" />
                  <span className="nav-label">{item.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {showEmployeeForm && (
        <EmployeeForm
          branches={branches}
          locations={locations}
          userRole={userRole}
          onClose={() => setShowEmployeeForm(false)}
        />
      )}

      {showCourseForm && <CourseCreationForm onClose={() => setShowCourseForm(false)} />}

      {showCourseDetails && (
        <CourseDetailsView
          onClose={() => setShowCourseDetails(false)}
          onDelete={(courseId) => console.log("Course deleted:", courseId)}
        />
      )}
      {showSupportPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Support</h3>
            <p>If you have any queries related to this application, contact <strong>Mr.Hari -9025680801</strong></p>
            <p>For any escalations, contact <strong>Mr.Muthu – 9176655299</strong></p>
            <button className="closes-btn" onClick={() => setShowSupportPopup(false)}>
              Close
            </button>
          </div>
        </div>
      )}


      {showMyProfile && <MyProfile onClose={() => setShowMyProfile(false)} />}
    </>
  );
};

export default ProfileAvatarsr;